<template>
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.4,21.4l-2.4-4.1c-1-1.7-2.8-2.7-4.7-2.8h-4.7c-1.8,0-3.4,0.9-4.4,2.3l0-8.8c0-1-0.8-1.7-1.7-1.7c-0.5,0-0.9,0.2-1.2,0.5C10,7.1,9.8,7.5,9.8,8l0,16.1v0c0,0.9,0.2,1.9,0.7,2.7l2.4,4.1c1,1.7,2.8,2.7,4.7,2.8h4.7c1.9,0,3.7-1.1,4.7-2.8l2.4-4.1C30.4,25.2,30.4,23.1,29.4,21.4z M26.5,25.2l-2.4,4.1c-0.4,0.7-1.1,1.1-1.8,1.1h-4.7c-0.8,0-1.4-0.4-1.8-1.1l-2.4-4.1c-0.4-0.7-0.4-1.5,0-2.1l2.4-4.1c0.4-0.7,1.1-1.1,1.8-1.1h4.7c0.8,0,1.4,0.4,1.8,1.1l2.4,4.1C26.9,23.7,26.9,24.5,26.5,25.2z"
    />
  </svg>
</template>

<style scoped lang="scss">
path {
  fill: var(--color-primary-logo);
}
</style>
